// extracted by mini-css-extract-plugin
export default {"container":"NQLyR0","column":"CsKvVY","row":"gqIHo5"};